import React from "react";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportPayorMemberPrefixesModal = ({ onImport, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/payor_prefix_mappings/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      onImport={handleImport}
      title="Import Payor Prefixes"
      exampleDownloadPath="/admin/payor_prefix_mappings/example"
      buttonProps={rest}
    />
  );
};
